import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import { formatDateTime } from "../../helpers/helpers";

let produtoId = 0;

export default function ProdutoPertoUsuario() {
  const [dadosFiltros, setDadosFiltros] = useState({
    nome: "",
    cpf: "",
    email: "",
  });
  const [comboProdutos, setComboProdutos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const { notification } = useContext(AppContext);
  const [lista, setLista] = useState([]);
  const [usuario, setUsuario] = useState({});

  useEffect(() => {
    carregarProdutos();
  }, []);

  const carregarProdutos = () => {
    setCarregando(true);
    api
      .get("produtosPerto/listar")
      .then((comboProdutosPerto) => {
        setComboProdutos(comboProdutosPerto);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar os produtos");
        setCarregando(false);
      });
  };

  const produtoSelecionado = (produto) => {
    produtoId = produto.produto;

    if (usuario.usuarioId) {
      abrirProf(usuario);
    }
  };

  const buscarUsuario = (params) => {
    let dadosParams = {
      nome: params.nome,
      CPF: params.cpf,
      email: params.email,
    };

    setDadosFiltros(dadosParams);
    setCarregando(true);

    api
      .get("profissionais/listar", dadosParams)
      .then((res) => {
        setLista(res);
        setCarregando(false);
        setUsuario({});
      })
      .catch((err) => {
        notification("error", "Não foi possível listar profissionais");
        setCarregando(false);
      });
  };

  const fProduto = {
    title: "Produto Perto",
    form: {
      produto: {
        label: "Produto Perto",
        type: "select",
        emptyItem: true,
        array: {
          data: comboProdutos,
          value: "id",
          desc: "nome",
        },
        value: produtoId,
      },
    },
    submit: {
      action: produtoSelecionado,
      auto: true,
    },
  };

  const filtros = {
    title: "Buscar usuário",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 4,
        value: dadosFiltros.nome,
      },
      email: {
        label: "Email",
        type: "text",
        space: 4,
        value: dadosFiltros.email,
      },
      cpf: {
        label: "CPF",
        type: "number",
        space: 4,
        value: dadosFiltros.cpf,
      },
    },

    submit: {
      label: "Buscar",
      action: buscarUsuario,
    },
  };

  const abrirProf = (registro) => {
    if (!produtoId) return notification("warning", "Selecione um produto");
    setCarregando(true);

    api
      .get("produtosPerto/carregarUsuario", {
        produtoPertoId: produtoId,
        usuarioId: registro.usuarioId,
      })
      .then((res) => {
        setUsuario(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar profissionais");
        setCarregando(false);
      });
  };

  const tRegistros = {
    title: "Profissionais localizados",
    onLineClick: abrirProf,
    columns: [
      {
        name: "usuarioNome",
        label: "Nome",
      },
      {
        name: "usuarioEmail",
        label: "Email",
      },
    ],
    array: lista,
  };

  const camposVinculoUsuarioProdutoPerto = (usuarioProdutoPertoVinculo) => {
    const campos = {
      nome: {
        label: "Profissional",
        type: "text",
        value: usuarioProdutoPertoVinculo.usuarioNome,
        space: 4,
        enabled: false,
        readOnly: true,
      },
      email: {
        label: "Email",
        type: "text",
        value: usuarioProdutoPertoVinculo.usuarioEmail,
        space: 4,
        readOnly: true,
      },
      expiracaoAcesso: {
        label: "Acesso expira em",
        type: "date",
        value: formatDateTime(
          usuarioProdutoPertoVinculo.expiracaoAcesso,
          "Y-M-D"
        ),
        space: 4,
      },
    };

    if (!usuarioProdutoPertoVinculo.produtoPertoId) {
      campos.mensagemVinculo = {
        label: "Profissional não vinculado.",
        type: "text",
        value:
          'O profissional não tem vínculo com o produto selecionado. Clique em "Criar vínculo" caso deseje criar um.',
        readOnly: true,
      };
    }

    if (usuarioProdutoPertoVinculo.expirado) {
      campos.mensagemVinculo = {
        label: "Não vinculado",
        type: "text",
        value:
          "O acesso do profissional ao produto foi suspenso por desvínculo ou expiração. Para reestabelecer o acesso, informe uma nova data futura de expiração.",
        readOnly: true,
      };
    }

    return campos;
  };

  const vincularUsuarioProdutoPerto = (form) => {
    const vinculoCriar = {
      usuarioId: usuario.usuarioId,
      produtoPertoId: produtoId,
      expiracaoAcesso: form.expiracaoAcesso,
    };

    api
      .post("produtosPerto/vincularUsuario", vinculoCriar)
      .then((resultado) => {
        notification("success", "Profissional vinculado ao produto.");
        abrirProf(usuario);
      })
      .catch((err) => notification("error", "Erro ao vincular o grupo "));
  };

  const desvinculuarUsuarioProdutoPerto = () => {
    const vinculoCriar = {
      usuarioId: usuario.usuarioId,
      produtoPertoId: produtoId,
    };

    api
      .post("produtosPerto/desvincularUsuario", vinculoCriar)
      .then((resultado) => {
        notification("success", "Profissional desvinculado ao produto.");
        abrirProf(usuario);
      })
      .catch((err) =>
        notification("error", "Erro ao desvincular profissional ")
      );
  };

  const editarVinculo = (form) => {
    const vinculoEditar = {
      usuarioId: usuario.usuarioId,
      produtoPertoId: produtoId,
      expiracaoAcesso: form.expiracaoAcesso,
    };

    api
      .post("produtosPerto/editarUsuario", vinculoEditar)
      .then(() => {
        notification("success", "Vínculo editado");
        abrirProf(usuario);
      })
      .catch((err) => notification("error", "Erro ao editar vinculo "));
  };

  const fProdutoPertoUsuario = {
    form: camposVinculoUsuarioProdutoPerto(usuario),
    title: "Usuário x Produto Perto",
    submit: usuario.produtoPertoId
      ? {
          label: "Salvar",
          action: editarVinculo,
        }
      : {
          label: "Criar vínculo",
          action: vincularUsuarioProdutoPerto,
        },

    customActions:
      usuario.produtoPertoId && !usuario.expirado
        ? [
            {
              label: "Desvincular",
              action: () => desvinculuarUsuarioProdutoPerto(),
            },
          ]
        : undefined,
  };

  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={fProduto} />}
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          {usuario.usuarioId ? (
            <Form formData={fProdutoPertoUsuario} />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </div>
  );
}
